const currency = require('./currency-service');
const percent = require('./percent-service');
const number = require('./number-service');

module.exports = {
    currency,
    percent,
    number
};